import { Component, OnInit, Input, ElementRef, HostListener, OnDestroy } from '@angular/core';

import { cloneDeep } from 'lodash';
import { Subscription } from 'rxjs';

import { DragService, DragEventType } from '../../services/drag.service';
import { ToolAdapterService } from '../../tools/tool-adapter.service';

import { ControlSpecification } from '../../types/specification.types';
import { AbstractControl } from '../../types/control.types';

@Component({
  selector: 'df-drag-box',
  templateUrl: './drag-box.component.html',
  styleUrls: ['./drag-box.component.css']
})
export class DragBoxComponent implements OnInit, OnDestroy {
  @Input() specification: ControlSpecification;
  private isDraging: boolean = false;
  private container: AbstractControl<any>;

  private dragEndSubscription: Subscription;
  private dragEndAtControlSubscription: Subscription;
  private dragEventSubscription: Subscription;

  constructor(private dragService: DragService, private el: ElementRef, private toolService: ToolAdapterService) {}

  ngOnInit() {
    this.el.nativeElement.style.position = 'absolute';
    this.bindDragEvent();
    this.bindDragEndAtControl();
    this.bindDragEnd();
  }

  ngOnDestroy(): void {
    this.unBindDrag();
  }

  // çå¬documentç§»å¨äºä»¶äºä»¶
  @HostListener('document:mousemove', ['$event']) onMousemove(event: any) {
    // å¤æ­è¯¥åç´ æ¯å¦è¢«ç¹å»äºã
    const x = event.clientX + document.documentElement.scrollLeft || document.body.scrollLeft;
    const y = event.clientY + document.documentElement.scrollTop || document.body.scrollTop;
    this.el.nativeElement.style.left = x + 'px';
    this.el.nativeElement.style.top = y + 'px';
  }

  private bindDragEvent() {
    this.dragEventSubscription = this.dragService.dragEvent$.subscribe((s) => {
      if (s.eventType === DragEventType.Begin) {
        this.isDraging = true;
        this.container = undefined;
        this.specification = s.specification;
        this.toolService.changeCursor('grabbing');
      }
      if (s.eventType === DragEventType.Draging) {
        // è·éé¼ æ ç§»å¨
        if (this.specification) {
        }
      }
      if (s.eventType === DragEventType.End) {
        // ç»æåï¼å¤æ­ä½ç½®ï¼æ¯å¦å¼å§ç»åç´ 
        if (this.isDraging && this.specification) {
          this.dragService.sendDragEnd(cloneDeep(this.specification));
        }
        this.isDraging = false;
        this.specification = undefined;
        this.toolService.changeCursor('');
      }
    });
  }

  private bindDragEndAtControl() {
    this.dragEndAtControlSubscription = this.dragService.dragEndAtControl$.subscribe((s) => {
      if (!this.container) {
        this.container = s;
      }
    });
  }

  private bindDragEnd() {
    this.dragEndSubscription = this.dragService.dragEnd$.subscribe((s) => {
      if (!s) {
        return;
      }
      try {
        this.toolService.startDragDraw(s);
        this.toolService.do(this.container, {});
        this.toolService.startSelect();
      } catch {}
    });
  }

  private unBindDrag() {
    if (this.dragEndSubscription) {
      this.dragEndSubscription.unsubscribe();
    }
    if (this.dragEndAtControlSubscription) {
      this.dragEndAtControlSubscription.unsubscribe();
    }
    if (this.dragEventSubscription) {
      this.dragEventSubscription.unsubscribe();
    }
  }
}
